<div class="quote-request-page" [class.quote-request-page--guest]="!isLoggedIn()">
    <ng-container *ngIf="isLoggedIn(); else guestHeader">
        <header class="o360-page-header">
            <div class="o360-page-header__main">
                <button
                    type="button"
                    class="o360-page-header__back quote-request-page__back"
                    [routerLink]="catalogRoute">
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-narrow-left'"></mat-icon>
                    <span>Catálogo</span>
                </button>

                <div class="o360-page-header__context">{{ contextName }}</div>
                <h1>Pedido de orçamento</h1>
            </div>
        </header>
    </ng-container>

    <ng-template #guestHeader>
        <header class="quote-request-page__guest-header">
            <div class="quote-request-page__guest-brand">
                <img src="../../assets/images/logo/O360.svg" alt="Organiza360" class="quote-request-page__guest-logo" />
                <span>Organiza360</span>
            </div>

            <button routerLink="/" class="quote-request-page__guest-link">
                Entrar / Criar conta
            </button>
        </header>

        <section class="quote-request-page__guest-banner">
            <p>
                <strong>Crie a sua conta gratuitamente</strong> e experimente a gestão de eventos por <strong>7 dias sem limitações</strong>.
                Explore o catálogo e peça o seu orçamento sem compromisso.
            </p>
        </section>
    </ng-template>

    <div class="quote-request-page__content">
        <div class="quote-request-page__grid">
            <section class="quote-request-page__surface quote-request-page__surface--summary">
                <div class="quote-request-page__section-head">
                    <div class="quote-request-page__eyebrow">Resumo</div>
                    <h2>Produtos selecionados</h2>
                </div>

                <div class="quote-request-page__items">
                    <article *ngFor="let item of quoteItems" class="quote-request-page__item">
                        <div class="quote-request-page__item-main">
                            <img
                                *ngIf="item.images?.[0]"
                                [src]="item.images[0]"
                                alt="{{ item.name }}"
                                class="quote-request-page__item-image" />
                            <div>
                                <h3>{{ item.name }}</h3>
                            </div>
                        </div>

                        <span class="quote-request-page__item-qty">x{{ item.quantity }}</span>
                    </article>
                </div>

                <div class="quote-request-page__summary-footer">
                    <div class="quote-request-page__total">
                        <span>Total de itens</span>
                        <strong>{{ totalItems }}</strong>
                    </div>

                    <a [routerLink]="catalogRoute" class="quote-request-page__catalog-link">
                        <mat-icon [svgIcon]="'heroicons_outline:arrow-narrow-left'"></mat-icon>
                        <span>Voltar ao catálogo</span>
                    </a>
                </div>
            </section>

            <section class="quote-request-page__surface">
                <div class="quote-request-page__section-head">
                    <div class="quote-request-page__eyebrow">Pedido</div>
                    <h2>Dados para contacto</h2>
                </div>

                <form (ngSubmit)="submitQuote()" #quoteForm="ngForm" class="quote-request-form">
                    <div *ngIf="!isLoggedIn()" class="quote-request-form__grid">
                        <mat-form-field appearance="outline" class="quote-request-form__field">
                            <mat-label>Nome</mat-label>
                            <input matInput type="text" name="name" [(ngModel)]="formData.name" required>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="quote-request-form__field">
                            <mat-label>Email</mat-label>
                            <input matInput type="email" name="email" [(ngModel)]="formData.email" required>
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" class="quote-request-form__field quote-request-form__field--full">
                        <mat-label>Telefone</mat-label>
                        <input matInput type="tel" name="phone" [(ngModel)]="formData.phone" required>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="quote-request-form__field quote-request-form__field--full">
                        <mat-label>Mensagem</mat-label>
                        <textarea matInput name="message" rows="5" [(ngModel)]="formData.message"></textarea>
                    </mat-form-field>

                    <button
                        mat-flat-button
                        color="primary"
                        [disabled]="!quoteForm.form.valid || isSubmitting"
                        class="quote-request-form__submit"
                        type="submit">
                        <mat-progress-spinner
                            *ngIf="isSubmitting"
                            diameter="20"
                            mode="indeterminate"
                            color="accent"
                            class="quote-request-form__spinner"
                            strokeWidth="3">
                        </mat-progress-spinner>

                        <mat-icon *ngIf="!isSubmitting">send</mat-icon>
                        <span>{{ isSubmitting ? 'A enviar...' : 'Enviar pedido' }}</span>
                    </button>
                </form>
            </section>
        </div>
    </div>
</div>
